'use client';

import { useTranslations } from 'next-intl';

import { getFlipsterUrl } from '@flipster/features/src/shared/urls';
import { useCopy } from '@flipster/features/src/shared/webview/clipboard';
import { Button } from '@flipster/react/design-system/button';
import Share2Icon from '@flipster/react/icon/generated/Share2Icon';

import { GlossaryTermPageGlossaryTermFragment } from '../query.generated';

const ShareTermButton = ({ glossaryTerm }: { glossaryTerm: GlossaryTermPageGlossaryTermFragment }) => {
  const t = useTranslations();
  const copy = useCopy('Glossary link copied');
  const url = `${getFlipsterUrl()}/glossary/${glossaryTerm.slug}`;

  const onClickShareTermButton = () => {
    if (navigator.share) {
      navigator.share({ title: document.title, url });
    } else {
      copy(url);
    }
  };

  return (
    <Button
      icon={<Share2Icon />}
      label={t('Autogen_common.r251126.s_Share')}
      hierarchy='secondary'
      color='neutral'
      onClick={onClickShareTermButton}
      aria-label={t('Autogen_common.r251126.s_Copy_the_term_link_to_the_clipboard')}
      css={{ ml: 16 }}
    />
  );
};

export default ShareTermButton;
